import { ActionState, ActionStateEnum, IdleConstruction } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { Utils } from "../../utils/Utils";
import { EntityManager } from "../../plan/EntityManager";
import { PlanManager } from "../../../../cocosPlan";
import { Commands, ComponentConstants, Entity, EntityFactory, Events, eventsManager, Joinery, joineryManager, math, Room, roomManager, SavaneConstants, SceneConstants, Wall, wallManager } from "@rhinov/savane-js";

declare var cc: any;

export class EditWallState extends ActionState {

    state: number = ActionStateEnum.editWall;
    _wallEdited: Wall | null = null;
    _editedRoomDirect: Room | null = null;
    _editedRoomUndirect: Room | null = null;
    _roomContainingWalls: Room | null = null;
    _savedRooms: Room[] = [];
    _toRecompute: any[] = [];

    _directionFollowed1: math.vec3 | null = null;
    _canChangeDirection1: boolean = false;
    _otherDirection1: math.vec3 | null = null;
    _directionFollowed2: math.vec3 | null = null;
    _canChangeDirection2: boolean = false;
    _otherDirection2: math.vec3 | null = null;

    _wallDeleted: boolean = false;
    _beginPointPosition: math.vec3 | null = null;
    _endPointPosition: math.vec3 | null = null;
    _endPoint1: math.vec3 | null = null;
    _endPoint2: math.vec3 | null = null;

    _directionComputed: boolean = false;
    _cursorPosition: math.vec3 | null = null;

    _crossPoint: math.vec3 = math.vec3.create();
    _editNormal: math.vec3 = math.vec3.create();
    _editDirection: math.vec3 | null = null;

    _lastSnapPoint: math.vec3 | null = null;
    _nextSnapPoint: math.vec3 | null = null;
    _currentSnapPoint: math.vec3 | null = null;

    _lastCursorPosition: math.vec3 | null = null;
    _modifiedWalls1: Wall[] = [];
    _modifiedWalls2: Wall[] = [];

    //used to create command
    _wallsBeforeMerge: [Wall[], Wall[]] | [Wall | null, Wall | null] = [null, null];
    _wallsMerged: [Wall | null, Wall | null] = [null, null];
    _wallsBeforeCut: [Wall | null, Wall | null] = [null, null];
    _wallsCutted: [Wall[], Wall[]] | [Wall | null, Wall | null] = [null, null];

    //case modifiedWall.length === 1
    //walls to add (possible if modified.walls.length === 1 not at the begin of the edition)
    _wallsAdded: [Wall | null, Wall | null] = [null, null];
    //walls deleted on the scene (possible if modified.walls.length ===1 at the begin of the edition)
    _wallsDeleted: [Wall | null, Wall | null] = [null, null];

    _joineriesDeleted: Joinery[] = [];
    _joineriesPos: math.vec3[] = [];
    _joineriesToCheck: Joinery[] = [];
    _joineriesToCheckPos: math.vec3[] = [];
    _posBeforeSnap: math.vec3 | null = null;

    constructor(wallId: number) {
        super();
        

        this._wallEdited = PlanManager.getInstance().world.currentScene!.currentFloor!.getWall(wallId);

        // Can't find the wall being edited, leave here
        if (!this._wallEdited) {
            return;
        }

        this._beginPointPosition = math.vec3.clone(this._wallEdited!.begin);
        this._endPointPosition = math.vec3.clone(this._wallEdited!.end);

        this._endPoint1 = math.vec3.clone(this._wallEdited!.begin);
        this._endPoint2 = math.vec3.clone(this._wallEdited!.end);

        //Snap is handle thank to the distance from the cursor position to the crossing point between two lines:
        // - the line passing at wallsPoints of direction this.wallsEdited
        // - the line passing at the (0,0) of direction the normal of the wall edited
        
        this._editDirection = math.vec3.clone(this._wallEdited!.wallDirection);
        math.vec3.set(this._editNormal, -this._editDirection[1], this._editDirection[0], 0);
    }

    getAction(): number {
        return ActionStateEnum.editWall;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        // The wall to edit wasn't found, we simply go back to idleConstruction
        if (!this._wallEdited) {
            return this.mouseClickCancelled();
        }

        super.moveMouseCursor(cursorPosition);
        if (this._wallEdited!.locked === true) {
            return null;
        }
        var i;
        var room, mouseDirection, dist, dir1, dir2; // FIXME this function need a big refacto with subfunctions
        //compute direction
        if (this._lastCursorPosition !== null && !this._directionComputed &&
            math.vec3.distance(this._lastCursorPosition, cursorPosition) > SavaneConstants.PositionTolerance) {
            this._directionComputed = true;

            this._wallEdited!.startTemporary();
            for (i = this._wallEdited!.rooms.length - 1; i >= 0; i--) {
                room = this._wallEdited!.rooms[i];
                this.saveAndDeleteRooms(room);
                (room as any).parent = PlanManager.getInstance().world.currentScene!.currentFloor!;
                if (room.wallOrientationInRoom(this._wallEdited)) {
                    this._editedRoomDirect = room;
                } else {
                    this._editedRoomUndirect = room;
                }
            }

            if (this._editedRoomUndirect === null && this._editedRoomDirect === null) {
                var roomList = PlanManager.getInstance().world.currentScene!.currentFloor!.rooms;
                for (i = 0; i < roomList.length; i++) {
                    if (roomList[i].nonRoomedWalls.indexOf(this._wallEdited) !== -1) {
                        room = roomList[i];
                        this.saveAndDeleteRooms(room);
                        room.parent = PlanManager.getInstance().world.currentScene!.currentFloor!;
                        this._roomContainingWalls = room;
                        break;
                    }
                }
            }

            var followedWall1 = wallManager.getWallsAtCorner(this._wallEdited!.begin, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance)!;
            for (i = 0; i < followedWall1.length; i++) {
                if (followedWall1[i].id === this._wallEdited!.id) {
                    followedWall1.splice(i, 1);
                    break;
                }
            }
            var followedWall2 = wallManager.getWallsAtCorner(this._wallEdited!.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance)!;
            for (i = 0; i < followedWall2.length; i++) {
                if (followedWall2[i].id === this._wallEdited!.id) {
                    followedWall2.splice(i, 1);
                    break;
                }
            }

            if (followedWall1.length > 2 || followedWall2.length > 2 ||
                (followedWall1.length === 2 && !Wall.areColinear(followedWall1[0], followedWall1[1], SavaneConstants.ToleranceCollinear)) ||
                (followedWall2.length === 2 && !Wall.areColinear(followedWall2[0], followedWall2[1], SavaneConstants.ToleranceCollinear)) ||
                this._wallEdited!.canBeginHaveOffset() || this._wallEdited!.canEndHaveOffset() ||
                (followedWall1.length === 1 && Wall.areColinear(this._wallEdited, followedWall1[0], SavaneConstants.ToleranceCollinear)) ||
                (followedWall2.length === 1 && Wall.areColinear(this._wallEdited, followedWall2[0], SavaneConstants.ToleranceCollinear))) {
                this._currentSnapPoint = this.getSnapPoint(this._wallEdited!.begin);

                if (followedWall1.length < 2 || (followedWall1.length === 2 && Wall.areColinear(followedWall1[0], followedWall1[1])) || this._wallEdited!.canBeginHaveOffset()) {
                    this._modifiedWalls1 = [];
                    for (i = 0; i < followedWall1.length; i++) {
                        if (!Wall.areColinear(followedWall1[i], this._wallEdited, 100 * SavaneConstants.Tolerance)) {
                            this._modifiedWalls1.push(followedWall1[i]);
                            this._modifiedWalls1[this._modifiedWalls1.length - 1].startTemporary();
                        }
                    }
                }

                if (followedWall2.length < 2 || (followedWall2.length === 2 && Wall.areColinear(followedWall2[0], followedWall2[1])) || this._wallEdited!.canEndHaveOffset()) {
                    this._modifiedWalls2 = [];
                    for (i = 0; i < followedWall2.length; i++) {
                        if (!Wall.areColinear(followedWall2[i], this._wallEdited, 100 * SavaneConstants.Tolerance)) {
                            this._modifiedWalls2.push(followedWall2[i]);
                            this._modifiedWalls2[this._modifiedWalls2.length - 1].startTemporary();
                        }
                    }
                }


            } else {
                var cursorProjectionOnNormal = this.getSnapPoint(this._wallEdited!.begin);
                this.computeSnapPoint(cursorProjectionOnNormal, followedWall1, followedWall2);
                this._modifiedWalls1 = followedWall1;
                for (i = 0; i < this._modifiedWalls1.length;) {
                    if (Wall.areColinear(this._modifiedWalls1[i], this._wallEdited)) {
                        this._modifiedWalls1 = [];
                        break;
                    } else {
                        this._modifiedWalls1[i].startTemporary();
                        i++;
                    }
                }
                this._modifiedWalls2 = followedWall2;
                for (i = 0; i < this._modifiedWalls2.length;) {
                    if (Wall.areColinear(this._modifiedWalls2[i], this._wallEdited)) {
                        this._modifiedWalls2 = [];
                        break;
                    } else {
                        this._modifiedWalls2[i].startTemporary();
                        i++;
                    }
                }
            }

            mouseDirection = math.vec3.create();
            math.vec3.set(mouseDirection, cursorPosition[0] - this._lastCursorPosition![0],
                cursorPosition[1] - this._lastCursorPosition![1], 0);
            math.vec3.normalize(mouseDirection, mouseDirection);
            this.computeDirection(followedWall1, mouseDirection, true);
            this.computeDirection(followedWall2, mouseDirection, false);
        }

        if (this._directionComputed) {
            this._cursorPosition = math.vec3.clone(cursorPosition);
            var finalProjectionOnNormal = this.getSnapPoint(cursorPosition);
            var lastProjectionOnNormal = this.getSnapPoint(this._wallEdited!.begin);

            mouseDirection = math.vec3.create();
            math.vec3.set(mouseDirection, finalProjectionOnNormal[0] - lastProjectionOnNormal[0],
                finalProjectionOnNormal[1] - lastProjectionOnNormal[1], 0);
            math.vec3.normalize(mouseDirection, mouseDirection);

            var toProcess = true;
            var tmpCursorPosition = math.vec3.create();
            if (this._currentSnapPoint !== null) {
                if (math.vec3.distance(this._currentSnapPoint!, this.getSnapPoint(this._beginPointPosition!)) < SavaneConstants.PositionTolerance) {
                    if (this._canChangeDirection1) {
                        if (math.vec3.distance(mouseDirection, this._directionFollowed1!) >
                            math.vec3.distance(mouseDirection, this._otherDirection1!)) {
                            var tmpDir1 = math.vec3.clone(this._directionFollowed1!);
                            this._directionFollowed1 = math.vec3.clone(this._otherDirection1!);
                            this._otherDirection1 = tmpDir1;
                        }
                    }
                    if (this._canChangeDirection2) {
                        if (math.vec3.distance(mouseDirection, this._directionFollowed2!) >
                            math.vec3.distance(mouseDirection, this._otherDirection2!)) {
                            var tmpDir2 = math.vec3.clone(this._directionFollowed2!);
                            this._directionFollowed2 = math.vec3.clone(this._otherDirection2!);
                            this._otherDirection2 = tmpDir2;
                        }
                    }
                }

                dist = math.vec3.distance(this._currentSnapPoint, finalProjectionOnNormal);
                if (dist > Utils.magnetDistance && this.isAllowed(finalProjectionOnNormal)) {
                    dist = 1.1;
                    tmpCursorPosition = math.vec3.clone(this._currentSnapPoint);
                    tmpCursorPosition[0] += mouseDirection[0] * dist;
                    tmpCursorPosition[1] += mouseDirection[1] * dist;
                } else {
                    this.updateAdjacentWall(this._wallEdited);
                    toProcess = false;
                }
            } else {
                tmpCursorPosition = math.vec3.clone(cursorPosition);
                this._posBeforeSnap = math.vec3.clone(lastProjectionOnNormal);
                if (this._lastSnapPoint !== null) {
                    dir1 = math.vec3.create();
                    math.vec3.set(dir1, lastProjectionOnNormal[0] - finalProjectionOnNormal[0], lastProjectionOnNormal[1] - finalProjectionOnNormal[1], 0);
                    math.vec3.normalize(dir1, dir1);
                    dir2 = math.vec3.create();
                    math.vec3.set(dir2, this._lastSnapPoint[0] - finalProjectionOnNormal[0], this._lastSnapPoint[1] - finalProjectionOnNormal[1], 0);
                    math.vec3.normalize(dir2, dir2);
                    if (math.vec3.distance(dir1, dir2) < SavaneConstants.Tolerance &&
                        ((math.vec3.distance(lastProjectionOnNormal, finalProjectionOnNormal) > math.vec3.distance(this._lastSnapPoint, finalProjectionOnNormal) ||
                            math.vec3.distance(this._lastSnapPoint, finalProjectionOnNormal) < Utils.magnetDistance))) {
                        tmpCursorPosition = math.vec3.clone(this._lastSnapPoint);
                    }
                }

                if (this._nextSnapPoint !== null) {
                    dir1 = math.vec3.create();
                    math.vec3.set(dir1, lastProjectionOnNormal[0] - finalProjectionOnNormal[0], lastProjectionOnNormal[1] - finalProjectionOnNormal[1], 0);
                    math.vec3.normalize(dir1, dir1);
                    dir2 = math.vec3.create();
                    math.vec3.set(dir2, this._nextSnapPoint[0] - finalProjectionOnNormal[0], this._nextSnapPoint[1] - finalProjectionOnNormal[1], 0);
                    math.vec3.normalize(dir2, dir2);
                    if (math.vec3.distance(dir1, dir2) < SavaneConstants.Tolerance &&
                        ((math.vec3.distance(lastProjectionOnNormal, finalProjectionOnNormal) > math.vec3.distance(this._nextSnapPoint, finalProjectionOnNormal) ||
                            math.vec3.distance(this._nextSnapPoint, finalProjectionOnNormal) < Utils.magnetDistance))) {
                        tmpCursorPosition = math.vec3.clone(this._nextSnapPoint);
                    }
                }
            }
            var tmpProjectionOnNormal = this.getSnapPoint(tmpCursorPosition);
            //while is needed if the user move his mouse too fast to snap/unsnapp
            while (toProcess && math.vec3.distance(finalProjectionOnNormal, tmpProjectionOnNormal) > SavaneConstants.PositionTolerance) {
                lastProjectionOnNormal = this.getSnapPoint(tmpCursorPosition);
                this.processEdition(tmpCursorPosition, mouseDirection);

                //update tmpPoint
                if (this._currentSnapPoint !== null) {
                    dist = math.vec3.distance(this._currentSnapPoint, finalProjectionOnNormal);
                    if (dist > Utils.magnetDistance && this.isAllowed(finalProjectionOnNormal)) {
                        tmpCursorPosition = math.vec3.clone(this._currentSnapPoint);
                        dist = 1.1;
                        tmpCursorPosition[0] += mouseDirection[0] * dist;
                        tmpCursorPosition[1] += mouseDirection[1] * dist;
                    } else {
                        this.updateAdjacentWall(this._wallEdited);
                        toProcess = false;
                    }
                } else {
                    this._posBeforeSnap = math.vec3.clone(lastProjectionOnNormal);
                    tmpCursorPosition = math.vec3.clone(cursorPosition);
                    if (this._lastSnapPoint !== null) {
                        dir1 = math.vec3.create();
                        math.vec3.set(dir1, lastProjectionOnNormal[0] - finalProjectionOnNormal[0], lastProjectionOnNormal[1] - finalProjectionOnNormal[1], 0);
                        math.vec3.normalize(dir1, dir1);
                        dir2 = math.vec3.create();
                        math.vec3.set(dir2, this._lastSnapPoint[0] - finalProjectionOnNormal[0], this._lastSnapPoint[1] - finalProjectionOnNormal[1], 0);
                        math.vec3.normalize(dir2, dir2);
                        if (math.vec3.distance(dir1, dir2) < SavaneConstants.Tolerance &&
                            ((math.vec3.distance(lastProjectionOnNormal, finalProjectionOnNormal) > math.vec3.distance(this._lastSnapPoint, finalProjectionOnNormal) ||
                                math.vec3.distance(this._lastSnapPoint, finalProjectionOnNormal) < Utils.magnetDistance))) {
                            tmpCursorPosition = math.vec3.clone(this._lastSnapPoint);
                        }
                    }

                    if (this._nextSnapPoint !== null) {
                        dir1 = math.vec3.create();
                        math.vec3.set(dir1, lastProjectionOnNormal[0] - finalProjectionOnNormal[0], lastProjectionOnNormal[1] - finalProjectionOnNormal[1], 0);
                        math.vec3.normalize(dir1, dir1);
                        dir2 = math.vec3.create();
                        math.vec3.set(dir2, this._nextSnapPoint[0] - finalProjectionOnNormal[0], this._nextSnapPoint[1] - finalProjectionOnNormal[1], 0);
                        math.vec3.normalize(dir2, dir2);
                        if (math.vec3.distance(dir1, dir2) < SavaneConstants.Tolerance &&
                            ((math.vec3.distance(lastProjectionOnNormal, finalProjectionOnNormal) > math.vec3.distance(this._nextSnapPoint, finalProjectionOnNormal) ||
                                math.vec3.distance(this._nextSnapPoint, finalProjectionOnNormal) < Utils.magnetDistance))) {
                            tmpCursorPosition = math.vec3.clone(this._nextSnapPoint);
                        }
                    }
                }
                tmpProjectionOnNormal = this.getSnapPoint(tmpCursorPosition);
            }
            if (toProcess) {
                this.processEdition(tmpCursorPosition, mouseDirection);
            }

        }

        this._lastCursorPosition = math.vec3.clone(cursorPosition);
        return null;
    }

    mouseClickCancelled(cursorPosition?: math.vec3): ActionState | null {
        PlanManager.getInstance().updateItemsSelected(null);
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, ActionStateEnum.IdleConstruction);
        return new IdleConstruction();
    }

    keyPressed(keyCode: number, ctrl?: boolean, alt?: boolean): ActionState | null {
        // The wall to edit wasn't found, we simply go back to idleConstruction
        if (!this._wallEdited) {
            return(this.mouseClickCancelled());
        }

        if (keyCode === cc.KEY.escape) {
            return(this.mouseClickCancelled());
        }

        if (keyCode === cc.KEY.Delete || keyCode === cc.KEY.backspace) {
            PlanManager.getInstance().executeCommand(new Commands.DeleteWallCommand([this._wallEdited!], PlanManager.getInstance().selectedEntities));
            this._wallDeleted = true;
            return(this.mouseClickCancelled());
        }

        return null;
    }

    processEdition(tmpCursorPosition: math.vec3, mouseDirection: math.vec3) {
        if (this._currentSnapPoint !== null) {
            if (math.vec3.distance(this._currentSnapPoint, tmpCursorPosition) > SavaneConstants.PositionTolerance) {
                if (math.vec3.distance(this._currentSnapPoint!, this.getSnapPoint(this._beginPointPosition!)) < SavaneConstants.PositionTolerance) {
                    if (this._canChangeDirection1) {
                        if (math.vec3.distance(mouseDirection, this._directionFollowed1!) >
                            math.vec3.distance(mouseDirection, this._otherDirection1!)) {
                            var tmpDir1 = math.vec3.clone(this._directionFollowed1!);
                            this._directionFollowed1 = math.vec3.clone(this._otherDirection1!);
                            this._otherDirection1 = tmpDir1;
                        }
                    }
                    if (this._canChangeDirection2) {
                        if (math.vec3.distance(mouseDirection, this._directionFollowed2!) >
                            math.vec3.distance(mouseDirection, this._otherDirection2!)) {
                            var tmpDir2 = math.vec3.clone(this._directionFollowed2!);
                            this._directionFollowed2 = math.vec3.clone(this._otherDirection2!);
                            this._otherDirection2 = tmpDir2;
                        }
                    }
                }

                this.unSnapEditedWall(tmpCursorPosition);
                this.moveEditedWall(tmpCursorPosition);
                this.computeSnapPoint(tmpCursorPosition, this._modifiedWalls1, this._modifiedWalls2);

            }
        } else {
            if ((this._lastSnapPoint !== null && math.vec3.distance(this._lastSnapPoint, tmpCursorPosition) < Utils.magnetDistance) ||
                (this._nextSnapPoint !== null && math.vec3.distance(this._nextSnapPoint, tmpCursorPosition) < Utils.magnetDistance)) {
                this.snapEditedWall(tmpCursorPosition);
            } else {
                this.moveEditedWall(tmpCursorPosition);
            }
        }
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Wall[], mouseButton: number): ActionState | null {
        // The wall to edit wasn't found, we simply go back to idleConstruction
        if (!this._wallEdited) {
            return(this.mouseClickCancelled());
        }

        var i;
        var planManager = PlanManager.getInstance();
        if (this._directionComputed) {
            var valid = this._wallEdited!.isValid(planManager.world.currentScene!.currentFloor!);

            for (i = 0; i < this._modifiedWalls2.length; i++) {
                valid = valid ? this._modifiedWalls2[i].isValid(planManager.world.currentScene!.currentFloor!) : false;
            }
            for (i = 0; i < this._modifiedWalls1.length; i++) {
                valid = valid ? this._modifiedWalls1[i].isValid(planManager.world.currentScene!.currentFloor!) : false;
            }


            if (this._editedRoomDirect !== null) {
                (this._editedRoomDirect as any).wallsOrderer = false;
                if (!this._editedRoomDirect.wallOrientationInRoom(this._wallEdited)) {
                    valid = false;
                }
            }
            if (this._editedRoomUndirect !== null) {
                (this._editedRoomUndirect as any).wallsOrderer = false;
                if (this._editedRoomUndirect.wallOrientationInRoom(this._wallEdited)) {
                    valid = false;
                }
            }

            for (i = 0; i < this._joineriesDeleted.length; i++) {
                this._joineriesDeleted[i].position = this._joineriesPos[i];
            }

            var command = null;
            if (valid && this._beginPointPosition && this._endPointPosition) {
                command = new Commands.EditWallCommand(this._wallEdited, this._modifiedWalls1, this._modifiedWalls2, this._wallsDeleted as Array<Wall>, this._wallsAdded as Array<Wall>,
                    this._wallsBeforeMerge as Array<Wall>, this._wallsMerged as Array<Wall>, this._wallsCutted as Array<Wall>, this._wallsBeforeCut as Array<Wall>, this._beginPointPosition,
                    this._endPointPosition, this._endPoint1!, this._endPoint2!, this._joineriesDeleted, this._joineriesToCheck, this._editedRoomDirect!, this._editedRoomUndirect!, this._toRecompute,
                    planManager.world.currentScene!.currentFloor!, planManager.selectedEntities);
            }
            this.dispose();
            this._directionComputed = false;
            if (command !== null) {
                planManager.executeCommand(command);
            }

        } else {
            planManager.updateItemsSelected([this._wallEdited], false, mouseButton === 2);
        }

        return new IdleConstruction();
    }

    moveEditedWall(cursorPos: math.vec3) {
        var i, j;
        var translation;
        var planManager = PlanManager.getInstance();
        
        //move the wall (delimiting by the wall segment)
        if (this._directionFollowed1 === null && this._directionFollowed2 === null) {
            this._endPoint1![0] = this._endPoint1![0] + cursorPos[0] - this._lastCursorPosition![0];
            this._endPoint1![1] = this._endPoint1![1] + cursorPos[1] - this._lastCursorPosition![1];
            this._endPoint2![0] = this._endPoint2![0] + cursorPos[0] - this._lastCursorPosition![0];
            this._endPoint2![1] = this._endPoint2![1] + cursorPos[1] - this._lastCursorPosition![1];

        } else if (this._directionFollowed1 !== null && this._directionFollowed2 === null) {
            translation = math.vec3.create();
            this._endPoint1 = this.getCrossPoint(this._directionFollowed1, this._endPoint1!, this._editDirection!, cursorPos);
            translation[0] = this._endPoint1![0] - this._wallEdited!.begin[0];
            translation[1] = this._endPoint1![1] - this._wallEdited!.begin[1];
            this._endPoint2![0] += translation[0];
            this._endPoint2![1] += translation[1];


        } else if (this._directionFollowed1 === null && this._directionFollowed2 !== null) {
            translation = math.vec3.create();
            this._endPoint2 = this.getCrossPoint(this._directionFollowed2, this._endPoint2!, this._editDirection!, cursorPos);
            translation[0] = this._endPoint2![0] - this._wallEdited!.end[0];
            translation[1] = this._endPoint2![1] - this._wallEdited!.end[1];
            this._endPoint1![0] += translation[0];
            this._endPoint1![1] += translation[1];

        } else {
            this._endPoint1 = this.getCrossPoint(this._directionFollowed1!, this._endPoint1!, this._editDirection!, cursorPos) || this._endPoint1;
            this._endPoint2 = this.getCrossPoint(this._directionFollowed2!, this._endPoint2!, this._editDirection!, cursorPos) || this._endPoint2;
        }

        var wall, position;
        for (i = 0; i < this._modifiedWalls1.length; i++) {
            wall = this._modifiedWalls1[i];
            var distOnWall = [];
            var direction = math.vec3.clone(wall.wallDirection);

            if (wall.isBegin(this._wallEdited!.begin)) {
                for (j = 0; j < wall.joineries.length; j++) {
                    distOnWall.push(math.vec2.dist(wall.shiftedEnd, wall.joineries[j].position));
                }
                wall.begin = this._endPoint1!;
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        position = math.vec3.clone(wall.joineries[j].position);
                        position[0] = wall.shiftedEnd[0] - direction[0] * distOnWall[j];
                        position[1] = wall.shiftedEnd[1] - direction[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }
                    else {
                        var deltaLength = wall.length - wall.length;
                        wall.joineries[j].transform.localMatrix[12] = wall.joineries[j].transform.localMatrix[12] + deltaLength;
                    }
                }

            } else {
                for (j = 0; j < wall.joineries.length; j++) {
                    distOnWall.push(math.vec2.dist(wall.shiftedBegin, wall.joineries[j].position));
                }
                wall.end = this._endPoint1!;
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        position = math.vec3.clone(wall.joineries[j].position);
                        position[0] = wall.shiftedBegin[0] + direction[0] * distOnWall[j];
                        position[1] = wall.shiftedBegin[1] + direction[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }
                }
            }
        }

        for (i = 0; i < this._modifiedWalls2.length; i++) {
            wall = this._modifiedWalls2[i];
            var distOnWall = [];
            var direction = math.vec3.clone(wall.wallDirection);

            if (wall.isBegin(this._wallEdited!.end)) {
                for (j = 0; j < wall.joineries.length; j++) {
                    distOnWall.push(math.vec2.dist(wall.shiftedEnd, wall.joineries[j].position));
                }
                wall.begin = this._endPoint2!;
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        position = math.vec3.clone(wall.joineries[j].position);
                        position[0] = wall.shiftedEnd[0] - direction[0] * distOnWall[j];
                        position[1] = wall.shiftedEnd[1] - direction[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }
                    else {
                        var deltaLength = wall.length - wall.length;
                        wall.joineries[j].transform.localMatrix[12] = wall.joineries[j].transform.localMatrix[12] + deltaLength;
                    }
                }

            } else {
                for (j = 0; j < wall.joineries.length; j++) {
                    distOnWall.push(math.vec2.dist(wall.shiftedBegin, wall.joineries[j].position));
                }
                wall.end = this._endPoint2!;
                for (j = 0; j < wall.joineries.length; j++) {
                    if (wall.joineries[j].joineryType !== SceneConstants.JoineryType.velux) {
                        position = math.vec3.clone(wall.joineries[j].position);
                        position[0] = wall.shiftedBegin[0] + direction[0] * distOnWall[j];
                        position[1] = wall.shiftedBegin[1] + direction[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }
                }
            }
        }

        for (j = this._joineriesDeleted.length - 1; j >= 0; j--) {
            var wallAtJoineryPos = wallManager.getWallsAtPosition(this._joineriesPos[j], planManager.world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);
            if (wallAtJoineryPos !== null && wallAtJoineryPos.length === 1) {
                this._joineriesDeleted[j].wall = wallAtJoineryPos[0];
                this._joineriesDeleted[j].position = this._joineriesPos[j];
                if (joineryManager.isJoineryValid(this._joineriesDeleted[j])) {
                    var joinery = this._joineriesDeleted.splice(j, 1)[0];
                    this._joineriesPos.splice(j, 1);
                    planManager.addJoinery(joinery);
                }
            }
        }

        translation = math.vec3.create();
        math.vec3.set(translation, this._endPoint1![0] - this._wallEdited!.begin[0], this._endPoint1![1] - this._wallEdited!.begin[1], 0);

        var pos = [];
        for (j = 0; j < this._wallEdited!.joineries.length; j++) {
            pos.push(math.vec3.clone(this._wallEdited!.joineries[j].position));
        }
        this._wallEdited!.begin = this._endPoint1!;
        this._wallEdited!.end = this._endPoint2!;

        for (j = 0; j < this._wallEdited!.joineries.length; j++) {
            var position: any = pos[j];
            position[0] += translation[0];
            position[1] += translation[1];
            this._wallEdited!.joineries[j].position = position;
        }


        var drawRoom = true;
        var valid;

        for (i = 0; i < this._modifiedWalls2.length; i++) {
            valid = this._modifiedWalls2[i].isValid(planManager.world.currentScene!.currentFloor!);
            this.updateAdjacentWall(this._modifiedWalls2[i]);
            GameObjectManager.drawWall(this._modifiedWalls2[i], valid, true, true);
            drawRoom = valid ? drawRoom : false;
        }
        for (i = 0; i < this._modifiedWalls1.length; i++) {
            valid = this._modifiedWalls1[i].isValid(planManager.world.currentScene!.currentFloor!);
            this.updateAdjacentWall(this._modifiedWalls1[i]);
            GameObjectManager.drawWall(this._modifiedWalls1[i], valid, true, true);
            drawRoom = valid ? drawRoom : false;
        }

        valid = this._wallEdited!.isValid(planManager.world.currentScene!.currentFloor!);


        if (this._editedRoomDirect !== null) {
            this._editedRoomDirect.wallsOrderer = false;
            if (!this._editedRoomDirect.wallOrientationInRoom(this._wallEdited!, undefined)) {
                valid = false;
            }
        }
        if (this._editedRoomUndirect !== null) {
            this._editedRoomUndirect.wallsOrderer = false;
            if (this._editedRoomUndirect.wallOrientationInRoom(this._wallEdited!, undefined)) {
                valid = false;
            }
        }

        GameObjectManager.drawWall(this._wallEdited, valid, true, true);
        drawRoom = valid ? drawRoom : false;

        var rooms = [];
        if (this._editedRoomDirect !== null) {
            rooms.push(this._editedRoomDirect);
        }
        if (this._editedRoomUndirect !== null) {
            rooms.push(this._editedRoomUndirect);
        }

        if (this._roomContainingWalls !== null) {
            rooms.push(this._roomContainingWalls);
        }

        if (drawRoom) {
            GameObjectManager.updateRooms(rooms, false);
        } else {
            for (i = 0; i < rooms.length; i++) {
                EntityManager.getInstance().deleteNodeAndChild(rooms[i]);
            }
        }
    }

    computeDirection(wallsAtPoint: Wall[], mouseDirection: math.vec3, isBegin: boolean) {
        var editedPoint;
        var editedDirection = math.vec3.clone(this._wallEdited!.wallDirection);
        if (isBegin) {
            editedPoint = this._wallEdited!.begin;
        } else {
            editedPoint = this._wallEdited!.end;
            editedDirection[0] = -editedDirection[0];
            editedDirection[1] = -editedDirection[1];
        }

        var directionFollowed = null;
        var canChangeDirection = false;
        var otherDirection = null;

        if (wallsAtPoint.length !== 0) {
            if (wallsAtPoint.length === 1) {

                directionFollowed = math.vec3.clone(wallsAtPoint[0].wallDirection);
                if (Wall.areColinear(wallsAtPoint[0], this._wallEdited!, 100 * SavaneConstants.Tolerance)) {
                    math.vec3.set(directionFollowed, -directionFollowed[1], directionFollowed[0], directionFollowed[2]);
                }
            } else {
                var normal1 = math.vec3.create();
                math.vec3.set(normal1, this._wallEdited!.wallDirection[1], -this._wallEdited!.wallDirection[0], 0);
                var normal2 = math.vec3.create();
                math.vec3.set(normal2, -this._wallEdited!.wallDirection[1], this._wallEdited!.wallDirection[0], 0);

                var nearerWallNormal1 = null;
                var minValueNormal1 = 0;
                var nearerWallNormal2 = null;
                var minValueNormal2 = 0;
                var directionI = math.vec3.create();
                for (var i = 0; i < wallsAtPoint.length; i++) {
                    math.vec3.copy(directionI, wallsAtPoint[i].wallDirection);
                    if (wallsAtPoint[i].isEnd(editedPoint)) {
                        directionI[0] = -directionI[0];
                        directionI[1] = -directionI[1];
                    }
                    if (math.vec3.distance(directionI, normal1) < math.vec3.distance(directionI, normal2)) {
                        if (nearerWallNormal1 === null) {
                            if (!Wall.areColinear(wallsAtPoint[i], this._wallEdited!)) {
                                nearerWallNormal1 = wallsAtPoint[i];
                                minValueNormal1 = math.vec3.distance(directionI, editedDirection);
                            }
                        } else {
                            if (minValueNormal1 > math.vec3.distance(directionI, editedDirection)) {
                                nearerWallNormal1 = wallsAtPoint[i];
                                minValueNormal1 = math.vec3.distance(directionI, editedDirection);
                            }
                        }
                    } else {
                        if (nearerWallNormal2 === null) {
                            if (!Wall.areColinear(wallsAtPoint[i], this._wallEdited!)) {
                                nearerWallNormal2 = wallsAtPoint[i];
                                minValueNormal2 = math.vec3.distance(directionI, editedDirection);
                            }
                        } else {
                            if (minValueNormal2 > math.vec3.distance(directionI, editedDirection)) {
                                nearerWallNormal2 = wallsAtPoint[i];
                                minValueNormal2 = math.vec3.distance(directionI, editedDirection);
                            }
                        }
                    }
                }

                if (nearerWallNormal1 !== null && nearerWallNormal2 !== null) {
                    if (Wall.areColinear(nearerWallNormal1, nearerWallNormal2)) {
                        directionFollowed = math.vec3.clone(nearerWallNormal1.wallDirection);
                    } else {
                        canChangeDirection = true;

                        var direction1 = math.vec3.clone(nearerWallNormal1.wallDirection);
                        if (nearerWallNormal1.isEnd(editedPoint)) {
                            direction1[0] = -direction1[0];
                            direction1[1] = -direction1[1];
                        }
                        var direction2 = math.vec3.clone(nearerWallNormal2.wallDirection);
                        if (nearerWallNormal2.isEnd(editedPoint)) {
                            direction2[0] = -direction2[0];
                            direction2[1] = -direction2[1];
                        }

                        if (math.vec3.distance(direction1, mouseDirection) > math.vec3.distance(direction2, mouseDirection)) {
                            directionFollowed = direction2;
                            otherDirection = direction1;
                        } else {
                            directionFollowed = direction1;
                            otherDirection = direction2;
                        }
                    }
                } else if (nearerWallNormal1 !== null) {
                    directionFollowed = math.vec3.clone(nearerWallNormal1.wallDirection);
                } else if (nearerWallNormal2 !== null) {
                    directionFollowed = math.vec3.clone(nearerWallNormal2.wallDirection);
                }
            }

            if (isBegin) {
                this._directionFollowed1 = directionFollowed;
                this._canChangeDirection1 = canChangeDirection;
                this._otherDirection1 = otherDirection;
            } else {
                this._directionFollowed2 = directionFollowed;
                this._canChangeDirection2 = canChangeDirection;
                this._otherDirection2 = otherDirection;
            }

        }
    }

    snapEditedWall(cursorPosition: math.vec3) {
        var i;
        var cursorProjectionOnNormal = this.getSnapPoint(cursorPosition);
        if (this._lastSnapPoint !== null && math.vec3.distance(this._lastSnapPoint, cursorProjectionOnNormal) < SavaneConstants.PositionTolerance) {
            this._currentSnapPoint = this._lastSnapPoint;
        } else {
            this._currentSnapPoint = this._nextSnapPoint;
        }
        this._lastSnapPoint = null;
        this._nextSnapPoint = null;

        var snapOnBegin = false;
        if (this._currentSnapPoint) {
            for (i = 0; i < this._modifiedWalls1.length; i++) {
                if (math.vec3.distance(this._wallEdited!.begin, this._modifiedWalls1[i].begin) < SavaneConstants.PositionTolerance &&
                    math.vec3.distance(this._currentSnapPoint, this.getSnapPoint(this._modifiedWalls1[i].end)) < SavaneConstants.PositionTolerance) {
                    snapOnBegin = true;
                    break;
                }
                if (math.vec3.distance(this._wallEdited!.begin, this._modifiedWalls1[i].end) < SavaneConstants.PositionTolerance &&
                    math.vec3.distance(this._currentSnapPoint, this.getSnapPoint(this._modifiedWalls1[i].begin)) < SavaneConstants.PositionTolerance) {
                    snapOnBegin = true;
                    break;
                }
            }
        }

        if (snapOnBegin) {
            if (this._modifiedWalls1.length === 2) {
                if (this._wallsCutted[0] !== null) {
                    this.mergeWalls(this._wallsBeforeCut[0]!, this._wallsCutted[0] as Wall[]);
                    this._wallsCutted[0] = null;
                    this._wallsBeforeCut[0] = null;
                } else {
                    this._wallsMerged[0] = wallManager.mergeWall(this._modifiedWalls1[0], this._modifiedWalls1[1]);
                    this._wallsBeforeMerge[0] = [this._modifiedWalls1[0], this._modifiedWalls1[1]];
                    this.mergeWalls(this._wallsMerged[0], this._wallsBeforeMerge[0]);
                }
            } else if (this._modifiedWalls1.length === 1) {
                if (this._wallsAdded[0] !== null && this._modifiedWalls1[0].id === this._wallsAdded[0].id) {
                    this.deleteWall(this._wallsAdded[0].id);
                    this._wallsAdded[0] = null;
                } else {
                    this._wallsDeleted[0] = this._modifiedWalls1[0];
                    this.deleteWall(this._wallsDeleted[0].id);
                }
            }
            for (i = 0; i < this._modifiedWalls1.length; i++) {
                this._modifiedWalls1[i].endTemporary();
            }

            this._modifiedWalls1 = [];
        }

        var snapOnEnd = false;
        if (this._currentSnapPoint) {
            for (i = 0; i < this._modifiedWalls2.length; i++) {
                if (math.vec3.distance(this._wallEdited!.end, this._modifiedWalls2[i].begin) < SavaneConstants.PositionTolerance &&
                    math.vec3.distance(this._currentSnapPoint, this.getSnapPoint(this._modifiedWalls2[i].end)) < SavaneConstants.PositionTolerance) {
                    snapOnEnd = true;
                    break;
                }
                if (math.vec3.distance(this._wallEdited!.end, this._modifiedWalls2[i].end) < SavaneConstants.PositionTolerance &&
                    math.vec3.distance(this._currentSnapPoint, this.getSnapPoint(this._modifiedWalls2[i].begin)) < SavaneConstants.PositionTolerance) {
                    snapOnEnd = true;
                    break;
                }
            }
        }

        if (snapOnEnd) {
            if (this._modifiedWalls2.length === 2) {
                if (this._wallsCutted[1] !== null) {
                    this.mergeWalls(this._wallsBeforeCut[1]!, this._wallsCutted[1] as Wall[]);
                    this._wallsCutted[1] = null;
                    this._wallsBeforeCut[1] = null;
                } else {
                    this._wallsMerged[1] = wallManager.mergeWall(this._modifiedWalls2[0], this._modifiedWalls2[1]);
                    this._wallsBeforeMerge[1] = [this._modifiedWalls2[0], this._modifiedWalls2[1]];
                    this.mergeWalls(this._wallsMerged[1], this._wallsBeforeMerge[1]);
                }
            } else if (this._modifiedWalls2.length === 1) {
                if (this._wallsAdded[1] !== null && this._modifiedWalls2[0].id === this._wallsAdded[1].id) {
                    this.deleteWall(this._wallsAdded[1].id);
                    this._wallsAdded[1] = null;
                } else {
                    this._wallsDeleted[1] = this._modifiedWalls2[0];
                    this.deleteWall(this._wallsDeleted[1].id);
                }
            }
            for (i = 0; i < this._modifiedWalls2.length; i++) {
                this._modifiedWalls2[i].endTemporary();
            }

            this._modifiedWalls2 = [];
        }

        if (this._currentSnapPoint) {
            this.moveEditedWall(this._currentSnapPoint);
        }
    }

    unSnapEditedWall(cursorPosition: math.vec3) {
        var i;
        var pointSnap, pointUnSnap, beforeSnapWall, unsnapDirection, unsnapDirectionInverse, wallDirection;
        if (this._directionFollowed1 !== null) {
            if (this._modifiedWalls1.length === 0) {
                pointSnap = math.vec3.clone(this._wallEdited!.begin);
                pointUnSnap = this.getCrossPoint(this._directionFollowed1!, pointSnap, this._editDirection!, cursorPosition);
                this._wallEdited!.begin = pointUnSnap;
                beforeSnapWall = null;

                unsnapDirection = math.vec3.create();
                math.vec3.set(unsnapDirection, pointUnSnap[0] - pointSnap[0],
                    pointUnSnap[1] - pointSnap[1], 0);
                math.vec3.normalize(unsnapDirection, unsnapDirection);


                unsnapDirectionInverse = math.vec3.clone(unsnapDirection);
                unsnapDirectionInverse[0] = -unsnapDirectionInverse[0];
                unsnapDirectionInverse[1] = -unsnapDirectionInverse[1];

                var followedWall1 = wallManager.getWallsAtCorner(pointSnap, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
                if (followedWall1 === null) {
                    followedWall1 = [];
                }
                for (i = followedWall1.length - 1; i >= 0; i--) {
                    if (followedWall1[i].id === this._wallEdited!.id) {
                        followedWall1.splice(i, 1);
                    } else {
                        wallDirection = math.vec3.clone(followedWall1[i].wallDirection);
                        if (followedWall1[i].isEnd(pointSnap)) {
                            wallDirection[0] = -wallDirection[0];
                            wallDirection[1] = -wallDirection[1];
                        }

                        if (math.vec3.distance(wallDirection, unsnapDirection) > SavaneConstants.Tolerance) {
                            var wallsFollowed1 = followedWall1.splice(i, 1);
                            if (math.vec3.distance(wallDirection, unsnapDirectionInverse) < SavaneConstants.Tolerance) {
                                beforeSnapWall = wallsFollowed1[0];
                            }
                        }
                    }
                }

                if (followedWall1.length === 1) {
                    if (this._wallsMerged[0] !== null && this._wallsMerged[0].id === (followedWall1 as Wall[])[0].id) {
                        const beforeMergeWalls = this._wallsBeforeMerge[0] as Wall[];
                        this._modifiedWalls1.push(beforeMergeWalls[0]);
                        this._modifiedWalls1.push(beforeMergeWalls[1]);
                        this._modifiedWalls1[0].startTemporary();
                        this._modifiedWalls1[1].startTemporary();
                        if (this._modifiedWalls1[0].isBegin(this._modifiedWalls1[1].begin)) {
                            this._modifiedWalls1[0].begin = pointUnSnap;
                            this._modifiedWalls1[1].begin = pointUnSnap;
                        } else if (this._modifiedWalls1[0].isEnd(this._modifiedWalls1[1].begin)) {
                            this._modifiedWalls1[0].end = pointUnSnap;
                            this._modifiedWalls1[1].begin = pointUnSnap;
                        } else if (this._modifiedWalls1[0].isEnd(this._modifiedWalls1[1].end)) {
                            this._modifiedWalls1[0].end = pointUnSnap;
                            this._modifiedWalls1[1].end = pointUnSnap;
                        } else {
                            this._modifiedWalls1[0].begin = pointUnSnap;
                            this._modifiedWalls1[1].end = pointUnSnap;
                        }
                        this.cutWall(this._wallsMerged[0], this._wallsBeforeMerge[0] as Wall[]);
                        this._wallsBeforeMerge[0] = null;
                        this._wallsMerged[0] = null;
                    } else {
                        this._wallsBeforeCut[0] = followedWall1[0];
                        this._wallsCutted[0] = wallManager.cutWall(followedWall1[0], pointUnSnap);
                        this._modifiedWalls1.push(this._wallsCutted[0][0]);
                        this._modifiedWalls1.push(this._wallsCutted[0][1]);
                        this.cutWall(this._wallsBeforeCut[0], this._wallsCutted[0]);
                    }
                } else if (followedWall1.length === 0) {
                    if (this._wallsDeleted[0] !== null && this._wallsDeleted[0].isCorner(pointSnap)) {
                        this._wallsDeleted[0].startTemporary();
                        if (this._wallsDeleted[0].isBegin(pointSnap)) {
                            this._wallsDeleted[0].end = pointUnSnap;
                        } else {
                            this._wallsDeleted[0].begin = pointUnSnap;
                        }
                        this.addWall(this._wallsDeleted[0]);
                        this._modifiedWalls1.push(this._wallsDeleted[0]);
                        this._wallsDeleted[0] = null;
                    } else {
                        this._modifiedWalls1.push(EntityFactory.getInstance().createWall(pointSnap, pointUnSnap));
                        this._wallsAdded[0] = this._modifiedWalls1[0];
                        this._wallsAdded[0].thickness = beforeSnapWall === null ? this._wallEdited!.thickness : beforeSnapWall.thickness;
                        this._wallsAdded[0].height = this._wallEdited!.height;
                        this.addWall(this._wallsAdded[0]);
                    }
                }

                for (i = 0; i < this._modifiedWalls1.length; i++) {
                    this._modifiedWalls1[i].startTemporary();
                }

            }
        }
        if (this._directionFollowed2 !== null) {
            if (this._modifiedWalls2.length === 0) {
                pointSnap = math.vec3.clone(this._wallEdited!.end);
                pointUnSnap = this.getCrossPoint(this._directionFollowed2!, pointSnap, this._editDirection!, cursorPosition);
                this._wallEdited!.end = pointUnSnap;
                beforeSnapWall = null;

                unsnapDirection = math.vec3.create();
                math.vec3.set(unsnapDirection, pointUnSnap[0] - pointSnap[0],
                    pointUnSnap[1] - pointSnap[1], 0);
                math.vec3.normalize(unsnapDirection, unsnapDirection);

                unsnapDirectionInverse = math.vec3.clone(unsnapDirection);
                unsnapDirectionInverse[0] = -unsnapDirectionInverse[0];
                unsnapDirectionInverse[1] = -unsnapDirectionInverse[1];

                var followedWall2 = wallManager.getWallsAtCorner(pointSnap, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
                if (followedWall2 === null) {
                    followedWall2 = [];
                }
                for (i = followedWall2.length - 1; i >= 0; i--) {
                    if (followedWall2[i].id === this._wallEdited!.id) {
                        followedWall2.splice(i, 1);
                    } else {
                        wallDirection = math.vec3.clone(followedWall2[i].wallDirection);
                        if (followedWall2[i].isEnd(pointSnap)) {
                            wallDirection[0] = -wallDirection[0];
                            wallDirection[1] = -wallDirection[1];
                        }

                        if (math.vec3.distance(wallDirection, unsnapDirection) > SavaneConstants.Tolerance) {
                            var wallsFollowed2 = followedWall2.splice(i, 1);
                            if (math.vec3.distance(wallDirection, unsnapDirectionInverse) < SavaneConstants.Tolerance) {
                                beforeSnapWall = wallsFollowed2[0];
                            }
                        }
                    }
                }

                if (followedWall2.length === 1) {
                    if (this._wallsMerged[1] !== null && this._wallsMerged[1].id === (followedWall2 as Wall[])[0].id) {
                        const beforeMergeWalls = this._wallsBeforeMerge[1] as Wall[];
                        this._modifiedWalls2.push(beforeMergeWalls[0]);
                        this._modifiedWalls2.push(beforeMergeWalls[1]);
                        this._modifiedWalls2[0].startTemporary();
                        this._modifiedWalls2[1].startTemporary();
                        if (this._modifiedWalls2[0].isBegin(this._modifiedWalls2[1].begin)) {
                            this._modifiedWalls2[0].begin = pointUnSnap;
                            this._modifiedWalls2[1].begin = pointUnSnap;
                        } else if (this._modifiedWalls2[0].isEnd(this._modifiedWalls2[1].begin)) {
                            this._modifiedWalls2[0].end = pointUnSnap;
                            this._modifiedWalls2[1].begin = pointUnSnap;
                        } else if (this._modifiedWalls2[0].isEnd(this._modifiedWalls2[1].end)) {
                            this._modifiedWalls2[0].end = pointUnSnap;
                            this._modifiedWalls2[1].end = pointUnSnap;
                        } else {
                            this._modifiedWalls2[0].begin = pointUnSnap;
                            this._modifiedWalls2[1].end = pointUnSnap;
                        }
                        this.cutWall(this._wallsMerged[1], this._wallsBeforeMerge[1] as Wall[]);
                        this._wallsBeforeMerge[1] = null;
                        this._wallsMerged[1] = null;
                    } else {
                        this._wallsBeforeCut[1] = followedWall2[0];
                        this._wallsCutted[1] = wallManager.cutWall(followedWall2[0], pointUnSnap);
                        this._modifiedWalls2.push(this._wallsCutted[1][0]);
                        this._modifiedWalls2.push(this._wallsCutted[1][1]);
                        this.cutWall(this._wallsBeforeCut[1], this._wallsCutted[1]);
                    }
                } else if (followedWall2.length === 0) {
                    if (this._wallsDeleted[1] !== null && this._wallsDeleted[1].isCorner(pointSnap)) {
                        this._wallsDeleted[1].startTemporary();
                        if (this._wallsDeleted[1].isBegin(pointSnap)) {
                            this._wallsDeleted[1].end = pointUnSnap;
                        } else {
                            this._wallsDeleted[1].begin = pointUnSnap;
                        }
                        this.addWall(this._wallsDeleted[1]);
                        this._modifiedWalls2.push(this._wallsDeleted[1]);
                        this._wallsDeleted[1] = null;
                    } else {

                        this._modifiedWalls2.push(EntityFactory.getInstance().createWall(pointSnap, pointUnSnap));
                        this._wallsAdded[1] = this._modifiedWalls2[0];
                        this._wallsAdded[1].thickness = beforeSnapWall === null ? this._wallEdited!.thickness : beforeSnapWall.thickness;
                        this._wallsAdded[1].height = this._wallEdited!.height;
                        this.addWall(this._wallsAdded[1]);
                    }
                }

                for (i = 0; i < this._modifiedWalls2.length; i++) {
                    this._modifiedWalls2[i].startTemporary();
                }

            }
        }
        this._currentSnapPoint = null;
    }

    //call this function only after unsnap the wall edited (array don't own the edited wall)
    computeSnapPoint(cursorProjectionOnNormal: math.vec3, wallsAtBegin: Wall[], wallsAtEnd: Wall[]) {
        var i;
        var point, projectionPoint, testDir;

        this._nextSnapPoint = null;
        this._lastSnapPoint = null;
        //FIXME Refacto using func ?
        for (i = 0; i < wallsAtBegin.length; i++) {
            point = wallsAtBegin[i].isBegin(this._wallEdited!.begin) ? wallsAtBegin[i].end : wallsAtBegin[i].begin;
            projectionPoint = this.getSnapPoint(point);
            testDir = math.vec3.create();
            math.vec3.set(testDir, cursorProjectionOnNormal[0] - projectionPoint[0], cursorProjectionOnNormal[1] - projectionPoint[1], 0);
            math.vec3.normalize(testDir, testDir);
            if (math.vec3.distance(this._editNormal, testDir) < 0.1) {
                if (this._nextSnapPoint === null || math.vec3.distance(this._nextSnapPoint, cursorProjectionOnNormal) >
                    math.vec3.distance(projectionPoint, cursorProjectionOnNormal)) {
                    this._nextSnapPoint = projectionPoint;
                }
            } else {
                if (this._lastSnapPoint === null || math.vec3.distance(this._lastSnapPoint, cursorProjectionOnNormal) >
                    math.vec3.distance(projectionPoint, cursorProjectionOnNormal)) {
                    this._lastSnapPoint = projectionPoint;
                }
            }
        }
        for (i = 0; i < wallsAtEnd.length; i++) {
            point = wallsAtEnd[i].isEnd(this._wallEdited!.end) ? wallsAtEnd[i].begin : wallsAtEnd[i].end;
            projectionPoint = this.getSnapPoint(point);
            testDir = math.vec3.create();
            math.vec3.set(testDir, cursorProjectionOnNormal[0] - projectionPoint[0], cursorProjectionOnNormal[1] - projectionPoint[1], 0);
            math.vec3.normalize(testDir, testDir);
            if (math.vec3.distance(this._editNormal, testDir) < 0.1) {
                if (this._nextSnapPoint === null || math.vec3.distance(this._nextSnapPoint, cursorProjectionOnNormal) >
                    math.vec3.distance(projectionPoint, cursorProjectionOnNormal)) {
                    this._nextSnapPoint = projectionPoint;
                }
            } else {
                if (this._lastSnapPoint === null || math.vec3.distance(this._lastSnapPoint, cursorProjectionOnNormal) >
                    math.vec3.distance(projectionPoint, cursorProjectionOnNormal)) {
                    this._lastSnapPoint = projectionPoint;
                }
            }
        }
    }

    getSnapPoint(point: math.vec3): math.vec3 {
        return this.getCrossPoint(this._editNormal, this._crossPoint, this._editDirection!, point);
    }

    getCrossPoint(direction0: math.vec3, point0: math.vec3, direction1: math.vec3, point1: math.vec3): math.vec3 {
        var crossPoint = math.vec3.create();
        //constant in the equation direction[1] * x - direction[0] * y + c= 0
        var c = direction0[1] * point0[0] - direction0[0] * point0[1];
        var c1 = direction1[1] * point1[0] - direction1[0] * point1[1];
        if (Math.abs(direction0[0]) < SavaneConstants.Tolerance) {
            crossPoint[0] = c / direction0[1];
        }
        else {
            crossPoint[0] = (c * direction1[0] - c1 * direction0[0]) / (direction0[1] * direction1[0] - direction0[0] * direction1[1]); //denominator !=0 because the line are not colinear
        }
        if (Math.abs(direction0[0]) < SavaneConstants.Tolerance) {
            crossPoint[1] = (direction1[1] * crossPoint[0] - c1) / direction1[0];
        }
        else {
            crossPoint[1] = (direction0[1] * crossPoint[0] - c) / direction0[0]; //direction0 != 0 because the line are not colinear
        }
        return crossPoint;
    }

    snapClick(): ActionState | null {
        return new IdleConstruction();
    }

    dispose() {
        // Can't find the wall being edited, leave here
        if (!this._wallEdited) {
            return;
        }

        var i, j;
        if (this._directionComputed) {
            this._wallEdited!.endTemporary();

            for (i = 0; i < this._modifiedWalls1.length; i++) {
                this._modifiedWalls1[i].endTemporary();
            }

            for (i = 0; i < this._modifiedWalls2.length; i++) {
                this._modifiedWalls2[i].endTemporary();
            }

            if (this._wallsDeleted[0] !== null) {
                this._wallsDeleted[0].endTemporary();
                this.addWall(this._wallsDeleted[0]);
            }
            if (this._wallsAdded[0] !== null) {
                this.deleteWall(this._wallsAdded[0].id);
            }

            if (this._wallsBeforeMerge[0] !== null) {
                (this._wallsBeforeMerge[0] as Wall[])[0].endTemporary();
                (this._wallsBeforeMerge[0] as Wall[])[1].endTemporary();
                this.cutWall(this._wallsMerged[0]!, this._wallsBeforeMerge[0] as Wall[]);
            }
            if (this._wallsCutted[0] !== null && this._wallsBeforeCut[0] !== null) {
                this._wallsBeforeCut[0].endTemporary();
                this.mergeWalls(this._wallsBeforeCut[0]!, this._wallsCutted[0] as Wall[]);
            }

            if (this._wallsAdded[1] !== null) {
                this.deleteWall(this._wallsAdded[1].id);
            }
            if (this._wallsDeleted[1] !== null) {
                this._wallsDeleted[1].endTemporary();
                this.addWall(this._wallsDeleted[1]);
            }
            if (this._wallsBeforeMerge[1] !== null) {
                (this._wallsBeforeMerge[1] as Wall[])[0].endTemporary();
                (this._wallsBeforeMerge[1] as Wall[])[1].endTemporary();
                this.cutWall(this._wallsMerged[1]!, this._wallsBeforeMerge[1] as Wall[]);
            }
            if (this._wallsCutted[1] !== null && this._wallsBeforeCut[1] !== null) {
                this._wallsBeforeCut[1].endTemporary();
                this.mergeWalls(this._wallsBeforeCut[1], this._wallsCutted[1] as Wall[]);
            }
            var wallAtJoineryPos, joinery;
            for (j = this._joineriesDeleted.length - 1; j >= 0; j--) {
                wallAtJoineryPos = wallManager.getWallsAtPosition(this._joineriesPos[j], PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);
                if (wallAtJoineryPos !== null && wallAtJoineryPos.length === 1) {
                    this._joineriesDeleted[j].wall = wallAtJoineryPos[0];
                }
                this._joineriesDeleted[j].endTemporary();
                joinery = this._joineriesDeleted.splice(j, 1)[0];
                PlanManager.getInstance().addJoinery(joinery);
                joinery.position = this._joineriesPos[j];
                this._joineriesPos.splice(j, 1);
            }

            for (j = this._joineriesToCheck.length - 1; j >= 0; j--) {
                wallAtJoineryPos = wallManager.getWallsAtPosition(this._joineriesToCheckPos[j], PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);
                if (wallAtJoineryPos !== null && wallAtJoineryPos.length === 1 && wallAtJoineryPos[0].id !== this._joineriesToCheck[j].wall.id) {
                    PlanManager.getInstance().deleteJoinery(this._joineriesToCheck[j].id);
                    this._joineriesToCheck[j].wall = wallAtJoineryPos[0];
                    joinery = this._joineriesToCheck.splice(j, 1)[0];
                    PlanManager.getInstance().addJoinery(joinery);
                    joinery.position = this._joineriesToCheckPos[j];
                    this._joineriesToCheckPos.splice(j, 1);
                }
            }

            if (!this._wallDeleted) {
                GameObjectManager.drawWall(this._wallEdited, true, false, false);
            }

            if (this._wallsDeleted[0] === null && this._wallsMerged[0] === null && this._wallsAdded[0] === null && this._wallsCutted[0] === null) {
                for (i = 0; i < this._modifiedWalls1.length; i++) {
                    this.updateAdjacentWall(this._modifiedWalls1[i]);
                    GameObjectManager.drawWall(this._modifiedWalls1[i], true, false, false);
                }
            }
            if (this._wallsDeleted[1] === null && this._wallsMerged[1] === null && this._wallsAdded[1] === null && this._wallsCutted[1] === null) {
                for (i = 0; i < this._modifiedWalls2.length; i++) {
                    this.updateAdjacentWall(this._modifiedWalls2[i]);
                    GameObjectManager.drawWall(this._modifiedWalls2[i], true, false, false);
                }
            }

            this.addSavedRooms();
            roomManager.manageNonRoomedWalls(PlanManager.getInstance().world.currentScene!.currentFloor!);
            //Wall node hovered
            if (!this._wallDeleted) {
                var node = EntityManager.getInstance().getNode(this._wallEdited);
                if (node) {
                    node.setHovered(false);
                }
            }
        }
    }

    //wrap function to handle room of the edited wall
    mergeWalls(wall: Wall, mergedWalls: Wall[]) {
        var i;
        var planManager = PlanManager.getInstance();

        if (this._roomContainingWalls !== null) {
            if (this._roomContainingWalls.walls.indexOf(mergedWalls[0]) === -1) {
                this._roomContainingWalls.deleteNonRoomedWall(mergedWalls[0].id);
                this._roomContainingWalls.deleteNonRoomedWall(mergedWalls[1].id);
                this._roomContainingWalls.addNonRoomedWall(wall);
            } else {
                this._roomContainingWalls.deleteWall(mergedWalls[0].id);
                this._roomContainingWalls.deleteWall(mergedWalls[1].id);
                this.insertWallsInRoom(this._roomContainingWalls, [wall]);
            }
        }

        if (this._editedRoomUndirect !== null) {
            for (i = 0; i < this._editedRoomUndirect.walls.length; i++) {
                if (this._editedRoomUndirect.walls[i].id === mergedWalls[0].id) {
                    if (mergedWalls[0].length < mergedWalls[1].length) {
                        this._editedRoomUndirect.deleteWall(mergedWalls[0].id);
                    } else {
                        this._editedRoomUndirect.walls[i] = wall;
                    }
                    break;
                }
                if (this._editedRoomUndirect.walls[i].id === mergedWalls[1].id) {
                    if (mergedWalls[1].length < mergedWalls[0].length) {
                        this._editedRoomUndirect.deleteWall(mergedWalls[1].id);
                    } else {
                        this._editedRoomUndirect.walls[i] = wall;
                    }
                    break;
                }
            }
            this._editedRoomUndirect.wallsOrderer = false;
        }
        if (this._editedRoomDirect !== null) {
            for (i = 0; i < this._editedRoomDirect.walls.length; i++) {
                if (this._editedRoomDirect.walls[i].id === mergedWalls[0].id) {
                    if (mergedWalls[0].length < mergedWalls[1].length) {
                        this._editedRoomDirect.deleteWall(mergedWalls[0].id);
                    } else {
                        this._editedRoomDirect.walls[i] = wall;
                    }
                    break;
                }
                if (this._editedRoomDirect.walls[i].id === mergedWalls[1].id) {
                    if (mergedWalls[1].length < mergedWalls[0].length) {
                        this._editedRoomDirect.deleteWall(mergedWalls[1].id);
                    } else {
                        this._editedRoomDirect.walls[i] = wall;
                    }
                    break;
                }
            }
            this._editedRoomDirect.wallsOrderer = false;
        }

        planManager.mergeWalls(wall, mergedWalls);

        for (i = 0; i < this._joineriesToCheck.length; i++) {
            for (var j = 0; j < wall.joineries.length; j++) {
                if (wall.joineries[j].id === this._joineriesToCheck[i].id) {
                    this._joineriesToCheck[i].wall = wall;
                    this._joineriesToCheck[i].position = this._joineriesToCheckPos[i];
                }
            }
        }
    }

    cutWall(wall: Wall, wallsCutted: Wall[]) {
        var i;
        var planManager = PlanManager.getInstance();

        planManager.cutWall(wall, wallsCutted);

        if (this._roomContainingWalls !== null) {
            if (this._roomContainingWalls.walls.indexOf(wall) === -1) {
                this._roomContainingWalls.deleteNonRoomedWall(wall.id);
                this._roomContainingWalls.addNonRoomedWall(wallsCutted[0]);
                this._roomContainingWalls.addNonRoomedWall(wallsCutted[1]);
            } else {
                this._roomContainingWalls.deleteWall(wall.id);
                this.insertWallsInRoom(this._roomContainingWalls, wallsCutted);
            }
        }

        var isReplaced, wallReplaced;
        if (this._editedRoomUndirect !== null) {
            isReplaced = false;
            for (i = 0; i < this._editedRoomUndirect.walls.length; i++) {
                if (this._editedRoomUndirect.walls[i].id === wall.id) {
                    isReplaced = true;
                    wallReplaced = wallsCutted[0].length < wallsCutted[1].length ? wallsCutted[1] : wallsCutted[0];
                    this._editedRoomUndirect.walls[i] = wallReplaced;
                    break;
                }
            }

            if (!isReplaced) {
                wallReplaced = wallsCutted[0].length < wallsCutted[1].length ? wallsCutted[0] : wallsCutted[1];
                this.insertWallsInRoom(this._editedRoomUndirect, [wallReplaced]);
            }
            this._editedRoomUndirect.wallsOrderer = false;
        }
        if (this._editedRoomDirect !== null) {
            isReplaced = false;
            for (i = 0; i < this._editedRoomDirect.walls.length; i++) {
                if (this._editedRoomDirect.walls[i].id === wall.id) {
                    isReplaced = true;
                    wallReplaced = wallsCutted[0].length < wallsCutted[1].length ? wallsCutted[1] : wallsCutted[0];
                    this._editedRoomDirect.walls[i] = wallReplaced;
                    break;
                }
            }

            if (!isReplaced) {
                wallReplaced = wallsCutted[0].length < wallsCutted[1].length ? wallsCutted[0] : wallsCutted[1];
                this.insertWallsInRoom(this._editedRoomDirect, [wallReplaced]);
            }
            this._editedRoomDirect.wallsOrderer = false;
        }
        for (i = 0; i < this._joineriesToCheck.length; i++) {
            this._joineriesToCheck[i].position = this._joineriesToCheckPos[i];
        }
    }

    addWall(wall: Wall) {
        var planManager = PlanManager.getInstance();

        planManager.addWall(wall, false);

        if (this._editedRoomUndirect !== null) {
            this.insertWallsInRoom(this._editedRoomUndirect, [wall]);
        }
        if (this._editedRoomDirect !== null) {
            this.insertWallsInRoom(this._editedRoomDirect, [wall]);
        }
        if (this._roomContainingWalls !== null) {
            this._roomContainingWalls.addNonRoomedWall(wall);
        }
    }

    deleteWall(wallId: number) {
        var planManager = PlanManager.getInstance();
        if (this._editedRoomUndirect !== null) {
            this._editedRoomUndirect.deleteWall(wallId);
            this._editedRoomUndirect.wallsOrderer = false;
        }
        if (this._editedRoomDirect !== null) {
            this._editedRoomDirect.deleteWall(wallId);
            this._editedRoomDirect.wallsOrderer = false;
        }
        if (this._roomContainingWalls !== null) {
            this._roomContainingWalls.deleteNonRoomedWall(wallId);
        }
        planManager.deleteWall(wallId, false);
    }

    insertWallsInRoom(room: Room, walls: Wall[]) {
        var i, j;
        if (walls.length !== 0) {
            var point1 = null;
            var point2 = null;

            if (walls.length === 1) {
                point1 = walls[0].begin;
                point2 = walls[0].end;
            } else {
                point1 = walls[1].isCorner(walls[0].begin) ? walls[0].end : walls[0].begin;
                point2 = walls[walls.length - 2].isCorner(walls[walls.length - 1].begin) ? walls[walls.length - 1].end : walls[walls.length - 1].begin;
            }

            for (i = 0; i < room.walls.length; i++) {
                var roomWall1 = room.walls[(room.walls.length - 1 + i) % room.walls.length];
                var roomWall2 = room.walls[i];

                if (roomWall1.isCorner(point1, 5 * SavaneConstants.PositionTolerance) && roomWall2.isCorner(point2, 5 * SavaneConstants.PositionTolerance)) {
                    for (j = 0; j < walls.length; j++) {
                        room.addWallAtIndex(walls[j], i + j);
                    }

                    break;
                } else if (roomWall1.isCorner(point2, 5 * SavaneConstants.PositionTolerance) && roomWall2.isCorner(point1, 5 * SavaneConstants.PositionTolerance)) {
                    for (j = walls.length - 1; j >= 0; j--) {
                        room.addWallAtIndex(walls[j], i + (walls.length - 1 - j));
                    }
                    break;
                }
            }
            room.wallsOrderer = false;
        }
    }

    saveAndDeleteRooms(room: Room) {
        var clonedRoom = EntityFactory.getInstance().cloneRoom(room, false, false);
        for (var i = 0; i < room.children.length; i++) {
            this._toRecompute.push(room.children[i]);
        }
        this._savedRooms.push(clonedRoom);
        for (var j = 0; j < room.walls.length; j++) {
            this._savedRooms[this._savedRooms.length - 1].addWall(room.walls[j]);
        }
        PlanManager.getInstance().world.currentScene!.currentFloor!.deleteRoom(room.id);
        EntityManager.getInstance().deleteNodeAndChild(room);
        //Recompute
        for (i = 0; i < this._toRecompute.length; i++) {
            var item = this._toRecompute[i];
            //Recompute parent
            if (item.isArrangementObjectEntity() || item.isArrangementGroupEntity() || item.isRenderCameraEntity() || item.isGeometryPrimitiveEntity() || item.isWorktopEntity()) {
                // Find containing room
                var roomContaining = null;

                if (item.isWorktopEntity()) {
                    var area = item.getComponent(ComponentConstants.ComponentType.Area);
                    if (area) {
                        roomContaining = roomManager.getRoomAtPosition(area.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                    }
                }
                else {
                    roomContaining = roomManager.getRoomAtPosition(item.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                }

                if (roomContaining !== null) {
                    //set item child of room
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    roomContaining.addChild(item);
                } else {
                    //set item child of floor
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    PlanManager.getInstance().world.currentScene!.currentFloor!.addChild(item);
                }
                //Graphical node
                var node = EntityManager.getInstance().getNode(item);
                if (node === null) {
                    //Create new node
                    EntityManager.getInstance().addEntity(item);
                }
            }
        }
    }

    addSavedRooms() {
        for (var i = 0; i < this._savedRooms.length; i++) {
            EntityManager.getInstance().deleteNodeAndChild(this._savedRooms[i]);
            this._savedRooms[i].wallsOrderer = true;
            PlanManager.getInstance().world.currentScene!.currentFloor!.addRoom(this._savedRooms[i]);
            GameObjectManager.drawRoom(this._savedRooms[i], false, null, false);
        }
        //Recompute
        for (i = 0; i < this._toRecompute.length; i++) {
            var item = this._toRecompute[i];
            //Recompute parent
            if (item.isArrangementObjectEntity() || item.isArrangementGroupEntity() || item.isRenderCameraEntity() || item.isGeometryPrimitiveEntity() || item.isWorktopEntity()) {
                // Find containing room
                var roomContaining = null;

                if (item.isWorktopEntity()) {
                    var area = item.getComponent(ComponentConstants.ComponentType.Area);
                    if (area) {
                        roomContaining = roomManager.getRoomAtPosition(area.vertices[0], PlanManager.getInstance().world.currentScene!.currentFloor!);
                    }
                }
                else {
                    roomContaining = roomManager.getRoomAtPosition(item.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
                }

                if (roomContaining !== null) {
                    //set item child of room
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    roomContaining.addChild(item);
                } else {
                    //set item child of floor
                    if (item.parent !== null) {
                        item.parent.deleteChild(item.id);
                    }
                    PlanManager.getInstance().world.currentScene!.currentFloor!.addChild(item);
                }
                //Graphical node
                var node = EntityManager.getInstance().getNode(item);
                if (node === null) {
                    //Create new node
                    EntityManager.getInstance().addEntity(item);
                }
            }
        }
    }

    isAllowed(finalProjectionOnNormal: math.vec3): boolean {
        var i, j;
        var beginWallDir, endWallDir, dir, crossVector;
        if (math.vec3.distance(this._currentSnapPoint!, finalProjectionOnNormal) > Utils.magnetDistance) {
            var editedDirection = math.vec3.create();
            math.vec3.set(editedDirection, finalProjectionOnNormal[0] - this._currentSnapPoint![0], finalProjectionOnNormal[1] - this._currentSnapPoint![1], 0);
            math.vec3.normalize(editedDirection, editedDirection);

            if (this._posBeforeSnap !== null) {
                var comeFromDir = math.vec3.create();
                math.vec3.set(comeFromDir, this._posBeforeSnap[0] - this._currentSnapPoint![0], this._posBeforeSnap[1] - this._currentSnapPoint![1], 0);
                math.vec3.normalize(comeFromDir, comeFromDir);
                if (math.vec3.distance(comeFromDir, editedDirection) < SavaneConstants.Tolerance) {
                    return true;
                }
            }

            if (math.vec3.distance(this._wallEdited!.begin, this._wallEdited!.end) < SavaneConstants.PositionTolerance) {
                return false;
            }


            var editNormalInverse = math.vec3.clone(this._editNormal);
            editNormalInverse[0] = -editNormalInverse[0];
            editNormalInverse[1] = -editNormalInverse[1];

            var beginWalls = wallManager.getWallsAtCorner(this._wallEdited!.begin, PlanManager.getInstance().world.currentScene!.currentFloor!) || [];
            var endWalls = wallManager.getWallsAtCorner(this._wallEdited!.end, PlanManager.getInstance().world.currentScene!.currentFloor!) || [];


            var wallDirection = math.vec3.clone(this._wallEdited!.wallDirection);
            var wallDirectionInverse = math.vec3.clone(wallDirection);
            wallDirectionInverse[0] = -wallDirectionInverse[0];
            wallDirectionInverse[1] = -wallDirectionInverse[1];

            math.vec3.distance(this._currentSnapPoint!, finalProjectionOnNormal);

            if (this._roomContainingWalls !== null) {
                var allowed = true;
                if (this._directionFollowed1 !== null) {
                    for (i = 0; i < beginWalls.length; i++) {
                        if (this._roomContainingWalls.walls.indexOf(beginWalls[i]) !== -1) {
                            beginWallDir = math.vec3.clone(beginWalls[i].wallDirection);
                            if (beginWalls[i].isEnd(this._wallEdited!.begin)) {
                                beginWallDir[0] = -beginWallDir[0];
                                beginWallDir[1] = -beginWallDir[1];
                            }


                            dir = math.vec3.clone(this._directionFollowed1);
                            dir[0] = -dir[0];
                            dir[1] = -dir[1];
                            if (math.vec3.distance(editedDirection, this._directionFollowed1) < math.vec3.distance(editedDirection, dir)) {
                                dir = this._directionFollowed1;
                            }

                            if (math.vec3.distance(beginWallDir, dir) < SavaneConstants.Tolerance) {
                                allowed = true;
                                break;
                            }

                            crossVector = math.vec3.create();
                            math.vec3.cross(crossVector, beginWallDir, this._directionFollowed1);
                            if (math.vec3.distance(beginWallDir, wallDirection) < math.vec3.distance(beginWallDir, wallDirectionInverse) &&
                                math.vec3.length(crossVector) > SavaneConstants.Tolerance) {
                                allowed = false;
                            }
                        }
                    }
                }
                if (this._directionFollowed2 !== null && allowed) {
                    for (i = 0; i < endWalls.length; i++) {
                        if (this._roomContainingWalls.walls.indexOf(endWalls[i]) !== -1) {
                            endWallDir = math.vec3.clone(endWalls[i].wallDirection);
                            if (endWalls[i].isEnd(this._wallEdited!.end)) {
                                endWallDir[0] = -endWallDir[0];
                                endWallDir[1] = -endWallDir[1];
                            }
                            dir = math.vec3.clone(this._directionFollowed2);
                            dir[0] = -dir[0];
                            dir[1] = -dir[1];
                            if (math.vec3.distance(editedDirection, this._directionFollowed2) < math.vec3.distance(editedDirection, dir)) {
                                dir = this._directionFollowed2;
                            }
                            if (math.vec3.distance(endWallDir, dir) < SavaneConstants.Tolerance) {
                                allowed = true;
                                break;
                            }

                            crossVector = math.vec3.create();
                            math.vec3.cross(crossVector, endWallDir, this._directionFollowed2);
                            if (math.vec3.distance(endWallDir, wallDirectionInverse) < math.vec3.distance(endWallDir, wallDirection) &&
                                math.vec3.length(crossVector) > SavaneConstants.Tolerance) {
                                allowed = false;
                            }
                        }
                    }
                }

                return allowed;
            } else {
                var directId = this._editedRoomDirect !== null ? this._editedRoomDirect.id : -1;
                var undirectId = this._editedRoomUndirect !== null ? this._editedRoomUndirect.id : -1;

                var center = math.vec3.create();
                var begin = math.vec3.create();
                var end = math.vec3.create();
                center[0] = this._wallEdited!.begin[0] + this._wallEdited!.wallDirection[0] * 5;
                center[1] = this._wallEdited!.begin[1] + this._wallEdited!.wallDirection[1] * 5;
                begin[0] = center[0] + editedDirection[0] * 10;
                begin[1] = center[1] + editedDirection[1] * 10;
                end[0] = center[0] - editedDirection[0] * 10;
                end[1] = center[1] - editedDirection[1] * 10;
                var testedWallBegin = EntityFactory.getInstance().createWall(begin, end);

                center = math.vec3.create();
                begin = math.vec3.create();
                end = math.vec3.create();
                center[0] = this._wallEdited!.end[0] - this._wallEdited!.wallDirection[0] * 5;
                center[1] = this._wallEdited!.end[1] - this._wallEdited!.wallDirection[1] * 5;
                begin[0] = center[0] + editedDirection[0] * 10;
                begin[1] = center[1] + editedDirection[1] * 10;
                end[0] = center[0] - editedDirection[0] * 10;
                end[1] = center[1] - editedDirection[1] * 10;
                var testedWallEnd = EntityFactory.getInstance().createWall(begin, end);


                /*for (i = 0; i < beginWalls.length; i++) {
                    var wallBegin = beginWalls[i];
                    for (j = 0; j < wallBegin.rooms.length; j++) {
                        if (wallBegin.rooms[j].id !== directId && wallBegin.rooms[j].id !== undirectId) {
                            if (Wall.areWallCrossing(testedWallBegin, wallBegin, SavaneConstants.PositionTolerance)) {
                                return false;
                            }
                        }
                    }
                }

                for (i = 0; i < endWalls.length; i++) {
                    var wallEnd = endWalls[i];
                    for (j = 0; j < wallEnd.rooms.length; j++) {
                        if (wallEnd.rooms[j].id !== directId && wallEnd.rooms[j].id !== undirectId) {
                            if (Wall.areWallCrossing(testedWallEnd, wallEnd, SavaneConstants.PositionTolerance)) {
                                return false;
                            }
                        }
                    }
                }*/

                if (math.vec3.distance(editedDirection, editNormalInverse) < math.vec3.distance(editedDirection, this._editNormal)) {
                    //test on directRoom
                    if (this._editedRoomDirect !== null) {
                        for (i = 0; i < beginWalls.length; i++) {
                            if (beginWalls[i].id !== this._wallEdited!.id && this._editedRoomDirect.walls.indexOf(beginWalls[i]) !== -1) {
                                beginWallDir = math.vec3.clone(beginWalls[i].wallDirection);
                                if (beginWalls[i].isEnd(this._wallEdited!.begin)) {
                                    beginWallDir[0] = -beginWallDir[0];
                                    beginWallDir[1] = -beginWallDir[1];
                                }

                                crossVector = math.vec3.create();
                                math.vec3.cross(crossVector, beginWallDir, this._directionFollowed1!);
                                if (math.vec3.distance(beginWallDir, wallDirection) < math.vec3.distance(beginWallDir, wallDirectionInverse) &&
                                    math.vec3.length(crossVector) > SavaneConstants.Tolerance) {
                                    return false;
                                }
                            }
                        }

                        for (i = 0; i < endWalls.length; i++) {
                            if (endWalls[i].id !== this._wallEdited!.id && this._editedRoomDirect.walls.indexOf(endWalls[i]) !== -1) {
                                endWallDir = math.vec3.clone(endWalls[i].wallDirection);
                                if (endWalls[i].isEnd(this._wallEdited!.end)) {
                                    endWallDir[0] = -endWallDir[0];
                                    endWallDir[1] = -endWallDir[1];
                                }

                                crossVector = math.vec3.create();
                                math.vec3.cross(crossVector, endWallDir, this._directionFollowed2!);
                                if (math.vec3.distance(endWallDir, wallDirectionInverse) < math.vec3.distance(endWallDir, wallDirection) &&
                                    math.vec3.length(crossVector) > SavaneConstants.Tolerance) {
                                    return false;
                                }
                            }
                        }
                    }
                } else {
                    //test on undirectRoom
                    if (this._editedRoomUndirect !== null) {
                        for (i = 0; i < beginWalls.length; i++) {
                            if (beginWalls[i].id !== this._wallEdited!.id && this._editedRoomUndirect.walls.indexOf(beginWalls[i]) !== -1) {
                                beginWallDir = math.vec3.clone(beginWalls[i].wallDirection);
                                if (beginWalls[i].isEnd(this._wallEdited!.begin)) {
                                    beginWallDir[0] = -beginWallDir[0];
                                    beginWallDir[1] = -beginWallDir[1];
                                }
                                crossVector = math.vec3.create();
                                math.vec3.cross(crossVector, beginWallDir, this._directionFollowed1!);

                                if (math.vec3.distance(beginWallDir, wallDirection) < math.vec3.distance(beginWallDir, wallDirectionInverse) &&
                                    math.vec3.length(crossVector) > SavaneConstants.Tolerance
                                ) {
                                    return false;
                                }
                            }
                        }

                        for (i = 0; i < endWalls.length; i++) {
                            if (endWalls[i].id !== this._wallEdited!.id && this._editedRoomUndirect.walls.indexOf(endWalls[i]) !== -1) {
                                endWallDir = math.vec3.clone(endWalls[i].wallDirection);
                                if (endWalls[i].isEnd(this._wallEdited!.end)) {
                                    endWallDir[0] = -endWallDir[0];
                                    endWallDir[1] = -endWallDir[1];
                                }
                                crossVector = math.vec3.create();
                                math.vec3.cross(crossVector, endWallDir, this._directionFollowed2!);

                                if (math.vec3.distance(endWallDir, wallDirectionInverse) < math.vec3.distance(endWallDir, wallDirection) &&
                                    math.vec3.length(crossVector) > SavaneConstants.Tolerance) {
                                    return false;
                                }
                            }
                        }
                    }
                }
                return true;
            }
        }
        return false;
    }

    updateAdjacentWall(wall: Wall) {
        var i, j;
        var wallToDraw, walls;
        walls = wallManager.getWallsAtPosition(wall.begin, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);
        if (walls !== null) {
            for (i = 0; i < walls.length; i++) {
                wallToDraw = walls[i];
                if (wall.id !== wallToDraw.id && wallToDraw.temporary === null) {
                    GameObjectManager.drawWall(wallToDraw, true, false, false, -1, null);
                    for (j = 0; j < wallToDraw.rooms.length; j++) {
                        GameObjectManager.drawRoom(wallToDraw.rooms[j], false, null, false);
                    }
                }
            }
        }

        walls = wallManager.getWallsAtPosition(wall.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance, -1);
        if (walls !== null) {
            for (i = 0; i < walls.length; i++) {
                wallToDraw = walls[i];
                if (wall.id !== wallToDraw.id && wallToDraw.temporary === null) {
                    GameObjectManager.drawWall(wallToDraw, true, false, false, -1, null);
                    for (j = 0; j < wallToDraw.rooms.length; j++) {
                        GameObjectManager.drawRoom(wallToDraw.rooms[j], false, null, false);
                    }
                }
            }
        }
    }
}
